import React, { createContext, useContext, useReducer, Dispatch } from "react";

type DevPlanAction =
  | { type: "set_feature"; payload: any }
  | { type: "set_scenario"; payload: any }
  | { type: "set_uiDesign"; payload: any }
  | { type: "set_dataModel"; payload: any }
  | { type: "set_uiCode"; payload: any }
  | { type: "set_uiRender"; payload: any }
  | { type: "reset" };

type AppContextType = {
  state: {
    feature?: string;
    scenario?: string;
    uiDesign?: string;
    dataModel?: string;
    uiCode?: string;
    uiRender?: any;
  };
  dispatch: Dispatch<DevPlanAction>;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export function AppProvider({ children }: { children?: React.ReactNode }) {
  function reducer(state: any, action: DevPlanAction) {
    switch (action.type) {
      case "set_feature":
        return { ...state, feature: action.payload };
      case "set_scenario":
        return { ...state, scenario: action.payload };
      case "set_uiDesign":
        return { ...state, uiDesign: action.payload };
      case "set_dataModel":
        return { ...state, dataModel: action.payload };
      case "set_uiCode":
        return { ...state, uiCode: action.payload };
      case "set_uiRender":
        return { ...state, uiRender: action.payload };
      case "reset":
        return null;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, null);
  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useAppContext must be used within AppProvider");
  return ctx;
}
